module.exports = __webpack_public_path__ + "img/banner2.b60b47b6.jpg";